import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-mt-5" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  for: "code",
  class: "kn-material-input-label"
}
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-grid p-m-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: true,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    header: _ctx.formHeader,
    closable: false,
    style: _ctx.descriptor.form.style
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('common.close'),
        onClick: _ctx.closeTemplate
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.save'),
        disabled: _ctx.buttonDisabled,
        onClick: _ctx.handleSubmit
      }, null, 8, ["label", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", {
          class: "p-field p-col-12 p-mb-3",
          style: _ctx.descriptor.pField.style
        }, [
          _createVNode("span", _hoisted_2, [
            _createVNode(_component_InputText, {
              id: "code",
              modelValue: _ctx.v$.category.code.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.category.code.$model = $event)),
              modelModifiers: { trim: true },
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.category.code.$invalid && _ctx.v$.category.code.$dirty
                        }],
              type: "text",
              "max-length": "100",
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.category.code.$touch()))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.categoriesManagement.code')) + " *", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            "v-comp": _ctx.v$.category.code,
            "additional-translate-params": { fieldName: _ctx.$t('managers.categoriesManagement.code') }
          }, null, 8, ["v-comp", "additional-translate-params"])
        ], 4),
        _createVNode("div", {
          class: "p-field p-col-12 p-mb-3",
          style: _ctx.descriptor.pField.style
        }, [
          _createVNode("span", _hoisted_4, [
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: _ctx.v$.category.name.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.category.name.$model = $event)),
              modelModifiers: { trim: true },
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.category.name.$invalid && _ctx.v$.category.name.$dirty
                        }],
              type: "text",
              "max-length": "100",
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.category.name.$touch()))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.categoriesManagement.name')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            "v-comp": _ctx.v$.category.name,
            "additional-translate-params": { fieldName: _ctx.$t('managers.categoriesManagement.name') }
          }, null, 8, ["v-comp", "additional-translate-params"])
        ], 4),
        _createVNode("div", {
          class: "p-field p-col-12 p-mb-3",
          style: _ctx.descriptor.pField.style
        }, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.v$.category.type.$model,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.category.type.$model = $event)),
              class: ["kn-material-input kn-width-full", {
                            'p-invalid': _ctx.v$.category.type.$invalid && _ctx.v$.category.type.$dirty
                        }],
              options: _ctx.descriptor.availableTypes,
              "option-label": "label",
              "option-value": "code",
              disabled: _ctx.inputDisabled
            }, null, 8, ["modelValue", "options", "class", "disabled"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.categoriesManagement.type')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            "v-comp": _ctx.v$.category.type,
            "additional-translate-params": { fieldName: _ctx.$t('managers.categoriesManagement.type') }
          }, null, 8, ["v-comp", "additional-translate-params"])
        ], 4)
      ]),
      (_ctx.propCategory?.id && _ctx.categoryTags.length > 0)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "p-d-flex p-flex-column",
            style: _ctx.descriptor.chipsTable
          }, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.categoriesManagement.occurrences')), 1)
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryTags, (tag, index) => {
                return (_openBlock(), _createBlock("span", {
                  key: index,
                  class: "detail-chips"
                }, _toDisplayString(tag.name), 1))
              }), 128))
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["header", "style"]))
}